import { render, staticRenderFns } from "./Hall.vue?vue&type=template&id=519c9f16&scoped=true&"
import script from "./Hall.vue?vue&type=script&lang=js&"
export * from "./Hall.vue?vue&type=script&lang=js&"
import style0 from "./Hall.vue?vue&type=style&index=0&id=519c9f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519c9f16",
  null
  
)

export default component.exports